<template>
  <div id="mobile-sidebar" class="tw-fixed xl:tw-hidden tw-z-30">
    <nav class="navbar">
      <div class="navbar-container">
        <input
          class="tw-fixed tw-top-6 tw-left-5 tw-opacity-0 tw-w-10 tw-h-10 tw-cursor-pointer tw-z-40"
          type="checkbox"
          name="mobileSidebar"
          id="mobile-sidebar"
          ref="mobileSidebar"
        />
        <!-- Hamburger button -->
        <div
          class="hamburger-btn tw-fixed tw-top-6 tw-left-5 tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-xl tw-bg-[#E2E8F0] tw-z-20"
        >
          <!-- Hamburger icon -->
          <svg class="hamburger-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E293B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </div>

        <!-- Mobile menu panel -->
        <div
          class="menu-items tw-absolute tw-h-screen tw-w-80 tw-bg-white tw-border-r tw-border-[#E2E8F0] tw-pt-6 tw-z-10"
          :style="{ overflow: 'auto' }"
        >
          <!-- Header with Logo and Close button -->
          <div class="tw-px-6 tw-pb-8 tw-flex tw-items-center tw-justify-between">
            <img
              src="@/assets/img/logo-icon.svg"
              class="tw-h-8 tw-cursor-pointer"
              alt="getEquity"
              @click="homePage"
            />
            <!-- Close button -->
            <button
              @click="closeSidebar"
              class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-xl tw-bg-[#E2E8F0] hover:tw-bg-[#CBD5E1] tw-transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E293B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          <!-- Navigation items -->
          <div class="tw-px-3 tw-space-y-1">
            <SidebarMenu
              title="Overview"
              href="/dashboard/overview"
              :focus="overviewFocus || $route.path.includes('/dashboard/overview')"
              @click="closeSidebar"
            />
            <SidebarMenu
              v-if="hasPermission('deal:*')"
              title="Deals"
              href="/dashboard/deals"
              :focus="dealsFocus || $route.path.includes('/dashboard/deals')"
              @click="closeSidebar"
            />
            <SidebarMenu
              v-if="hasPermission('spv:*')"
              title="SPVs"
              href="/dashboard/spv"
              :focus="spvFocus || $route.path.includes('/dashboard/spv')"
              @click="closeSidebar"
            />
            <SidebarMenu
              v-if="hasPermission('invest:*')"
              title="Invest"
              href="/dashboard/invest"
              :focus="
                investFocus ||
                $route.path.includes('/dashboard/trade') ||
                $route.path.includes('/dashboard/invest')
              "
              @click="closeSidebar"
            />
            <SidebarMenu
              v-if="hasPermission('wallet:*') && hasPermission('bank:*')"
              title="Wallet"
              href="/dashboard/wallet"
              :focus="walletFocus || $route.path.includes('/dashboard/wallets')"
              @click="closeSidebar"
            />
            <SidebarMenu
              v-if="hasPermission('member:*')"
              title="Members"
              href="/dashboard/members"
              :focus="membersFocus || $route.path.includes('/dashboard/members')"
              @click="closeSidebar"
            />
            <SidebarMenu
              v-if="hasPermission('team:*')"
              title="Teams"
              href="/dashboard/teams"
              :focus="teamsFocus || $route.path.includes('/dashboard/teams')"
              @click="closeSidebar"
            />
            <SidebarMenu
              title="Account"
              href="/dashboard/account"
              :focus="accountFocus || $route.path.includes('/dashboard/account')"
              @click="closeSidebar"
            />
            <SidebarMenu
              v-if="hasPermission('api:*')"
              title="API"
              href="/dashboard/api-client"
              :focus="apiFocus || $route.path.includes('/dashboard/api-client')"
              @click="closeSidebar"
            />
          </div>

          <!-- Help section -->
          <!-- <div class="tw-px-3 tw-mt-8">
            <a 
              href="/faqs" 
              class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3 tw-rounded-xl tw-text-[#64748B] hover:tw-bg-[#F1F5F9] hover:tw-text-[#334155] tw-transition-colors tw-duration-200"
              @click="closeSidebar"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
              <span class="tw-text-sm tw-font-medium">Help & Support</span>
            </a>
          </div> -->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import SidebarMenu from "@/components/navigation/SidebarMenu.vue";
import { getItem } from "@/utils/storage";

export default {
  name: "MobileSidebar",

  components: { SidebarMenu },

  data() {
    return {
      overviewFocus: false,
      dealsFocus: false,
      spvFocus: false,
      walletFocus: false,
      membersFocus: false,
      teamsFocus: false,
      accountFocus: false,
      investFocus: false,
      apiFocus: false,
      userPermissions: [],
    };
  },

  created() {
    this.setFocus(this.$route.name);
    this.loadUserPermissions();
  },

  computed: {
    accountType() {
      const orgInfo = getItem("org_details");
      return orgInfo.type;
    },
  },

  methods: {
    homePage() {
      this.$router.push("/");
    },

    faqPage() {
      this.$router.push("/faqs");
    },

    closeSidebar() {
      this.$refs.mobileSidebar.checked = false;
    },

    setFocus(route) {
      this.overviewFocus = false;
      this.dealsFocus = false;
      this.spvFocus = false;
      this.walletFocus = false;
      this.membersFocus = false;
      this.teamsFocus = false;
      this.accountFocus = false;
      this.investFocus = false;
      this.apiFocus = false;
      switch (route) {
        case "OverviewDetails":
          this.overviewFocus = true;
          break;
        case "Deals":
          this.dealsFocus = true;
          break;
        case "DealInfo":
          this.dealsFocus = true;
          break;
        case "CreateDeal":
          this.dealsFocus = true;
          break;
        case "CreateAsset":
          this.dealsFocus = true;
          break;
        case "SPVs":
          this.spvFocus = true;
          break;
        case "Invest":
          this.investFocus = true;
          break;
        case "Trade":
          this.investFocus = true;
          break;
        case "TokenTrade":
          this.investFocus = true;
          break;
        case "InvestOrderbook":
          this.investFocus = true;
          break;
        case "TokenUpdates":
          this.investFocus = true;
          break;
        case "Wallet":
          this.walletFocus = true;
          break;
        case "Members":
          this.membersFocus = true;
          break;
        case "Team Members":
          this.teamsFocus = true;
          break;
        case "Account":
          this.accountFocus = true;
          break;
        case "ApiClient":
          this.apiFocus = true;
          break;
        case "ResetPassword":
          this.accountFocus = true;
          break;

        default:
          break;
      }
    },

    loadUserPermissions() {
      const teamMember = getItem("team_member");

      if (teamMember) {
        const parsedPermissions = teamMember.groups[0].permissions[0];

        console.log(parsedPermissions, "parsed");
        try {
          if (parsedPermissions) {
            if (parsedPermissions && parsedPermissions?.actions) {
              this.userPermissions = parsedPermissions?.actions;
            }
          }
        } catch (error) {
          console.error("Error parsing permissions:", error);
        }
      }
    },

    hasPermission(permission) {
      if (!this.userPermissions || this.userPermissions.length === 0) {
        return true;
      }

      if (permission.endsWith("*")) {
        const prefix = permission.slice(0, -1);
        return this.userPermissions.some((p) => p.startsWith(prefix));
      }

      return this.userPermissions.includes(permission);
    },
  },

  watch: {
    $route(to, from) {
      if (to !== from) {
        this.setFocus(this.$route.name);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#mobile-sidebar {
  @media (max-width: 1280px) {
    .navbar .menu-items {
      transform: translate(-150%);
      transition: transform 0.3s ease-in-out;
      scrollbar-width: thin;
      scrollbar-color: #E2E8F0 transparent;

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #E2E8F0;
        border-radius: 4px;
      }
    }

    .navbar-container input[type="checkbox"]:checked ~ .menu-items {
      transform: translateX(0);
    }

    .navbar-container input[type="checkbox"]:checked ~ .hamburger-btn {
      opacity: 0;
      pointer-events: none;
    }
  }
}
</style>
